import { ClientDTO } from '../services/clientApi';

export const TRANSIENT_NEW_CLIENT_TAG = 'Nouveau';

export const isCreatedToday = (createdAt?: string): boolean => {
  if (!createdAt) {
    return false;
  }

  const createdDate = new Date(createdAt);

  if (Number.isNaN(createdDate.getTime())) {
    return false;
  }

  const today = new Date();

  return createdDate.getFullYear() === today.getFullYear()
    && createdDate.getMonth() === today.getMonth()
    && createdDate.getDate() === today.getDate();
};

export const getDisplayTags = (client: ClientDTO): string[] => {
  const persistedTags = (client.tags || []).filter((tag) => tag !== TRANSIENT_NEW_CLIENT_TAG);

  if (isCreatedToday(client.createdAt)) {
    return [TRANSIENT_NEW_CLIENT_TAG, ...persistedTags];
  }

  return persistedTags;
};

export const formatClientDate = (value?: string): string => {
  if (!value) {
    return 'Non renseignée';
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return 'Non renseignée';
  }

  return new Intl.DateTimeFormat('fr-FR', {
    dateStyle: 'medium',
    timeStyle: 'short'
  }).format(date);
};